import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { ButtonText } from 'src/components/ButtonText';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  availableBrandTermsCount: PropTypes.number.isRequired,
  activeBrandVoiceCount: PropTypes.number.isRequired,
  onCtaClick: PropTypes.func.isRequired,
};

const defaultProps = {
  className: null,
};

export const EmptyTermsBanner = ({
  className,
  availableBrandTermsCount,
  activeBrandVoiceCount,
  onCtaClick,
}) => {
  const styles = useStyles();

  const { title, description, cta } = (() => {
    if (availableBrandTermsCount > 0 && activeBrandVoiceCount === 0) {
      return {
        title: 'Brand vocabulary is disabled.',
        cta: 'Enable brand vocabulary',
      };
    } else if (availableBrandTermsCount === 0) {
      return {
        title: 'Brand vocabulary hasn’t been set up yet',
        description: 'Add a list of approved terms that align with your guidelines.',
        cta: 'Add list',
      };
    }

    return {
      title: 'No issues found!',
      description: 'This text complies with your brand vocabulary.',
    };
  })();

  return (
    <div className={cx(styles.root, className)}>
      <CustomTypography
        className={styles.title}
        variant={TYPOGRAPHY_VARIANT.medium12}
      >
        {title}
      </CustomTypography>

      {description && (
        <CustomTypography
          className={styles.description}
          variant={TYPOGRAPHY_VARIANT.regular12}
        >
          {description}
        </CustomTypography>
      )}

      {cta && onCtaClick && (
        <ButtonText
          className={styles.buttonCta}
          onClick={onCtaClick}
        >
          {cta}
        </ButtonText>
      )}
    </div>
  );
};

EmptyTermsBanner.propTypes = propTypes;
EmptyTermsBanner.defaultProps = defaultProps;
